<template>
    <div class="or-admin-main">
        <or-admin-textarea class="nesting-main" :options="options['phone']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['phone-1']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['phone-2']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['phone-3']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['adress']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['email']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['director']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['feedback-email']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['service']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['user']" @unsaved="unsaved"/>
        <or-admin-textarea class="nesting-main" :options="options['pass']" @unsaved="unsaved"/>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orAdminTextarea from '../global/or-admin-textarea.vue'
export default {
    components: {orAdminTextarea},
    props: {
        options: Object,
    },
    methods: {
        ...mapActions({addUnsavedPage: 'addUnsavedPage'}),
        unsaved() {
            this.addUnsavedPage({page: 'info'})
        }
    }
    
}
</script>

<style>

</style>